import { AxiosError } from 'axios';

export const getMutationErrorMessage = (error: unknown) => {
  if (error instanceof AxiosError) {
    return (
      error.response?.data?.title ||
      error.response?.data?.message ||
      'Something went wrong'
    );
  }

  return 'Something went wrong';
};

export const isApplicationConfigurationNotFound = (error: unknown) => {
  if (!(error instanceof AxiosError)) {
    return false;
  }

  const statusCode = error.response?.status ?? error.status;
  return statusCode === 404;
};
